<template>
  <div class="articleFilter-list_container" :class="{ opened: openFilter }">
    <template v-for="(item, outerIndex) in initialdata">
      <h2 class="articleFilter-list_title">{{ item.title }}</h2>
      <div class="articleFilter-list_tags">
        <div
          class="tag-cta"
          v-for="(list, index) in item.facetlist"
          :key="item.query + '_' + list.name + '_' + index"
          :class="{ selected: isFacetSelected(item.query, list.name) }">
          <input
            type="checkbox"
            name="category"
            :id="'checkboxCategory_' + outerIndex + '_' + index"
            :checked="isFacetSelected(item.query, list.name)"
            @change="toggleFacet(outerIndex, index)"
          />
          <label :for="'checkboxCategory_' + outerIndex + '_' + index">{{
            list.name
          }}</label>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'articleFilterList',
  props: {
    initialdata: {
      type: [Object, Array],
      required: true,
    },
    openFilter: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
    removethisitem: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      selectedFacets: [],
      selectedFilters: {},
    };
  },
  watch: {
    selectedItems: {
      handler(newVal) {
        if (!Array.isArray(newVal)) return;
        const normalized = newVal.map((f) => ({
          query: f.query,
          name: f.name,
          title: f.title || this.getFilterTitle(f.query),
        }));
        if (!this.isSameSelectedFacets(this.selectedFacets, normalized)) {
          this.selectedFacets = normalized;
          this.syncFacetSelectedFromSelectedFacets();
        }
      },
      deep: true,
    },
    initialdata: {
      handler() {
        this.syncSelectedFacetsFromData();
      },
      deep: true,
    },
    selectedFacets: {
      handler(newVal) {
        this.buildSelectedFilters();
        this.$emit('update-selected-count', newVal, this.selectedFilters);
      },
      deep: true,
    },
  },
  created() {
    this.syncSelectedFacetsFromData();
    this.buildSelectedFilters();
  },
  methods: {
    getFilterTitle(query) {
      const filter = (this.initialdata || []).find((f) => f.query === query);
      return filter ? filter.title : '';
    },
    isSameSelectedFacets(a, b) {
      if (a.length !== b.length) return false;
      const key = (f) => f.query + '\0' + f.name;
      const setA = new Set(a.map(key));
      return b.every((f) => setA.has(key(f)));
    },
    isFacetSelected(query, name) {
      return this.selectedFacets.some((f) => f.query === query && f.name === name);
    },
    syncSelectedFacetsFromData() {
      if (!Array.isArray(this.initialdata)) return;
      const selected = [];
      this.initialdata.forEach((filter) => {
        (filter.facetlist || []).forEach((f) => {
          if (f.selected) {
            selected.push({
              query: filter.query,
              name: f.name,
              title: filter.title,
            });
          }
        });
      });
      this.selectedFacets = selected;
    },
    syncFacetSelectedFromSelectedFacets() {
      if (!Array.isArray(this.initialdata)) return;
      this.initialdata.forEach((filter) => {
        (filter.facetlist || []).forEach((f) => {
          f.selected = this.isFacetSelected(filter.query, f.name);
        });
      });
    },
    syncCheckedLabelsFromData() {
      this.syncSelectedFacetsFromData();
    },
    buildSelectedFilters() {
      this.selectedFilters = {};
      if (!Array.isArray(this.initialdata)) return;
      this.initialdata.forEach((filter) => {
        const selectedValues = (filter.facetlist || [])
          .filter((f) => f.selected)
          .map((f) => f.name);
        if (selectedValues.length) {
          this.selectedFilters[filter.query] = selectedValues;
        }
      });
    },
    getFilterFacetPayload(filterIndex) {
      const filter = this.initialdata[filterIndex];
      if (!filter || !filter.facetlist) return null;
      const selected = filter.facetlist.filter((f) => f.selected).map((f) => f.name);
      const unselected = filter.facetlist.filter((f) => !f.selected).map((f) => f.name);
      return {
        query: filter.query,
        title: filter.title,
        selected,
        unselected,
      };
    },
    toggleFacet(filterIndex, facetIndex) {
      const filter = this.initialdata[filterIndex];
      const facet = filter.facetlist[facetIndex];
      const selected = this.isFacetSelected(filter.query, facet.name);

      if (selected) {
        facet.selected = false;
        this.selectedFacets = this.selectedFacets.filter(
          (f) => !(f.query === filter.query && f.name === facet.name)
        );
      } else {
        facet.selected = true;
        this.selectedFacets = this.selectedFacets.slice();
        this.selectedFacets.push({
          query: filter.query,
          name: facet.name,
          title: filter.title,
        });
      }

      this.buildSelectedFilters();
      const payload = this.getFilterFacetPayload(filterIndex);
      this.$emit('facet-change', payload);
    },
  },
};
</script>
